/*
Copyright 2025 New Vector Ltd.
Copyright 2020 Bruno Windels <bruno@windels.cloud>
Copyright 2020 The Matrix.org Foundation C.I.C.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

import {TemplateView} from "../general/TemplateView";
import {AvatarView} from "../AvatarView";
import {StaticView} from "../general/StaticView";

export class CreateRoomView extends TemplateView {
    render(t, vm) {
        return t.main({className: "CreateRoomView middle"}, [
            t.div({className: "CreateRoomView_header middle-header"}, [
                t.a({className: "button-utility close-middle", href: vm.closeUrl, title: vm.i18n`Cancel room creation`}),
                t.div({className: "middle-header"}, [
                    t.a({className: "button-utility close-middle", href: vm.closeUrl, title: vm.i18n`Raum schlie�en`}),
                    t.h2("Raum erstellen"),
                ]),
            ]),
            t.div({className: "CreateRoomView_body centered-column"}, [
                //t.div({className: "RoomView_error"}, vm => vm.error),
                t.form({className: "CreateRoomView_detailsForm form", onChange: evt => this.onFormChange(evt), onSubmit: evt => this.onSubmit(evt)}, [
                    t.div({className: "vertical-layout"}, [
                        t.button({type: "button", className: "CreateRoomView_selectAvatar", onClick: () => vm.selectAvatar()},
                            t.mapView(vm => vm.hasAvatar, hasAvatar => {
                                if (hasAvatar) {
                                    return new AvatarView(vm, 64);
                                } else {
                                    return new StaticView(undefined, t => {
                                        return t.div({className: "CreateRoomView_selectAvatarPlaceholder"})
                                    });
                                }
                            })
                        ),
                        t.div({className: "stretch form-row text"}, [
                            t.label({for: "name"}, vm.i18n`Raumname`),
                            t.input({
                                onInput: evt => vm.setName(evt.target.value),
                                type: "text", name: "name", id: "name",
                                placeholder: vm.i18n`Geben Sie einen Raumnamen ein`
                            }),
                        ]),
                    ]),
                    t.div({className: "form-row text"}, [
                        t.label({for: "topic"}, vm.i18n`Thema (optional)`),
                        t.textarea({
                            onInput: evt => vm.setTopic(evt.target.value),
                            name: "topic", id: "topic",
                            placeholder: vm.i18n`Thema`
                        }),
                    ]),
                    t.div({className: "form-group"}, [
                        t.div({className: "form-row check"}, [
                            t.input({type: "radio", name: "isPublic", id: "isPrivate", value: "false", checked: !vm.isPublic}),
                            t.label({for: "isPrivate"}, vm.i18n`Privater Raum, nur auf Einladung.`)
                        ]),
                        t.div({className: "form-row check"}, [
                            t.input({type: "radio", name: "isPublic", id: "isPublic", value: "true", checked: vm.isPublic}),
                            t.label({for: "isPublic"}, vm.i18n`�ffentlicher Raum, jeder kann mitmachen`)
                        ]),
                    ]),
                    t.div({className: {"form-row check": true, hidden: vm => vm.isPublic}}, [
                        t.input({type: "checkbox", name: "isEncrypted", id: "isEncrypted", checked: vm.isEncrypted}),
                        t.label({for: "isEncrypted"}, vm.i18n`Aktivieren Sie die Ende-zu-Ende-Verschl�sselung`)
                    ]),
                    t.div({className: {"form-row text": true, hidden: vm => !vm.isPublic}}, [
                        t.label({for: "roomAlias"}, vm.i18n`Raum Alias`),
                        t.input({
                            onInput: evt => vm.setRoomAlias(evt.target.value),
                            type: "text", name: "roomAlias", id: "roomAlias",
                            placeholder: vm.i18n`Raum-Alias (<Alias>, oder #<Alias> oder #<Alias>:hs.tld`}),
                    ]),
                    t.div({className: "form-group"}, [
                        t.div(t.button({className: "link", type: "button", onClick: () => vm.toggleAdvancedShown()},
                            vm => vm.isAdvancedShown ? vm.i18n`Hide advanced settings` : vm.i18n`Erweiterte Einstellungen anzeigen`)),
                        t.div({className: {"form-row check": true, hidden: vm => !vm.isAdvancedShown}}, [
                            t.input({type: "checkbox", name: "isFederationDisabled", id: "isFederationDisabled", checked: vm.isFederationDisabled}),
                            t.label({for: "isFederationDisabled"}, [
                                vm.i18n`F�deration deaktivieren`,
                                t.p({className: "form-row-description"}, vm.i18n`Kann sp�ter nicht mehr ge�ndert werden. Dadurch wird verhindert, dass Personen auf anderen Homeservern dem Raum beitreten. Dies wird normalerweise verwendet, wenn nur Personen aus Ihrer eigenen Organisation (falls zutreffend) den Raum betreten d�rfen, und ansonsten nicht ben�tigt wird.`)
                            ]),
                        ]),
                    ]),
                    t.div({className: "button-row"}, [
                        t.button({
                            className: "button-action primary",
                            type: "submit",
                            disabled: vm => !vm.canCreate
                        }, vm.i18n`Raum erstellen`),
                    ]),
                ])
            ])
        ]);
    }

    onFormChange(evt) {
        switch (evt.target.name) {
            case "isEncrypted":
                this.value.setEncrypted(evt.target.checked);
                break;
            case "isPublic":
                this.value.setPublic(evt.currentTarget.isPublic.value === "true");
                break;
            case "isFederationDisabled":
                this.value.setFederationDisabled(evt.target.checked);
                break;
        }
    }

    onSubmit(evt) {
        evt.preventDefault();
        this.value.create();
    }
}
